import { Action } from '@ngrx/store';
import { IOebsConfig } from '../../../../commons';

export enum OebsConfigActionTypes {
  LoadOebsConfigState = '[OebsConfig] Load OebsConfig State',
  LoadOebsConfigStateSuccess = '[OebsConfig] Load OebsConfig State Success',
  LoadOebsConfigStateFail = '[OebsConfig] Load OebsConfig State Fail',
  OebsConfigScreenErrorReset = '[OebsConfig] OebsConfig Screen Error Reset'

}

export class LoadOebsConfigState implements Action {
  readonly type = OebsConfigActionTypes.LoadOebsConfigState;
}

export class LoadOebsConfigStateSuccess implements Action {
  readonly type = OebsConfigActionTypes.LoadOebsConfigStateSuccess;
  constructor(public payload: IOebsConfig ) {}
}

export class LoadOebsConfigStateFail implements Action {
  readonly type = OebsConfigActionTypes.LoadOebsConfigStateFail;
  constructor(public payload: any) {}
}

export class OebsConfigScreenErrorReset implements Action {
  readonly type = OebsConfigActionTypes.OebsConfigScreenErrorReset;
}

export type OebsConfigActions = 
  LoadOebsConfigState
  | LoadOebsConfigStateSuccess
  | LoadOebsConfigStateFail
  | OebsConfigScreenErrorReset;